import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import type { UserInfo } from '../types'
import { fetchUserInfo } from '../services/user-service'
import { toUserMessage } from '@/lib/error-messages'

export const useUserStore = defineStore('user', () => {
  const userInfo = ref<UserInfo | null>(null)
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  const cohort = computed(() => userInfo.value?.cohort ?? '')
  const school = computed(() => userInfo.value?.school ?? '')
  const preferences = computed(() => userInfo.value?.preferences ?? {})

  async function initialize(userId: string): Promise<void> {
    isLoading.value = true
    error.value = null
    try {
      const response = await fetchUserInfo(userId)
      userInfo.value = {
        cohort: response.cohort,
        school: response.school,
        preferences: response.preferences,
      }
    } catch (err) {
      error.value = toUserMessage(err)
      console.warn('[user] Failed to fetch user info:', err)
    } finally {
      isLoading.value = false
    }
  }

  return { userInfo, isLoading, error, cohort, school, preferences, initialize }
})
